import {
  BaseFullSchema_OLD,
  BaseRefSchema,
  BaseCreateSchema,
  BaseUpdateSchema,
  PaginatedResponse,
  IdAsUUID,
} from "./common/commonTypes";
import { InvPosRef } from "./invPosTypes";
import { UOMUnitRef } from "./uomTypes";

export const INV_MOV_STATUSES = ["REQUESTED", "COMPLETE", "VOID"] as const;
export type InvMovementStatusType = (typeof INV_MOV_STATUSES)[number];

export const INV_MOV_TYPES = [
  "ADJUSTMENT",
  "ALLOCATE",
  "BUILD",
  "CONSUME",
  "CUSTOMER_LOAN",
  "CUSTOMER_REPLACEMENT",
  "CUSTOMER_RETURN",
  "CYCLE_COUNT",
  "EXPIRE",
  "INSPECT",
  "OPENING_BALANCE",
  "ORDER_FULFILLMENT",
  "OUTSOURCED_MANUF",
  "PROD_TRANSFER",
  "QUARANTINE",
  "RECEIVE",
  "RELEASE",
  "RMA_RETURN",
  "SCRAP",
  "SHRINKAGE",
  "TRANSFER",
] as const;
export type InvMovementType = (typeof INV_MOV_TYPES)[number];

export interface InvMovFull extends BaseFullSchema_OLD {
  from_snapshot?: object;
  to_snapshot?: object;

  movement_status: InvMovementStatusType;
  movement_type: InvMovementType;
  quantity: string;
  quantity_base: string;

  movement_date: string;

  notes?: string;

  from_position?: InvPosRef;
  to_position?: InvPosRef;
  uom_unit: UOMUnitRef;
  batch: InvMovBatchRef;
}

export interface InvMovRef extends BaseFullSchema_OLD {
  movement_status: InvMovementStatusType;
  movement_type: InvMovementType;
  quantity: string;
  movement_date: string;
  from_position?: InvPosRef;
  to_position?: InvPosRef;
  uom_unit: UOMUnitRef;
  batch: InvMovBatchRef;
}

export interface InvMovFulfillment extends BaseRefSchema {
  quantity: string;
  uom_unit: string;
  from_bin: string;
  item: string;
  lot: string;
  date: string;
  sales_order: string;
}

export interface InvMovCreate extends BaseCreateSchema {
  from_position_id: string | null;
  to_location_id: string | null;
  to_status_id: string | null;
  lot_id: string | null;
  uom_unit_id: string;
  movement_type: InvMovementType;
  quantity: number;
  release_rev: string | null;
  expiration_date: string | null;
  ncs_to_link: string[];
  ncs_to_create: string[];
  rft: boolean | null;
  rw: boolean | null;
  pd: boolean | null;
  associated_id: string | null;
  associated_table: string | null;
  notes: string | null;
}

export interface InvMovUpdate extends BaseUpdateSchema {
  from_position_id?: string;
  to_position_id?: string;
  to_location_id?: string;
  to_status_id?: string;
  lot_id?: string;
  uom_unit_id?: string;
  quantity?: number;
  movement_type?: InvMovementType;
  associated_id?: string;
  associated_table?: string;
  notes?: string;
}

export interface InvMovBatchFull extends BaseFullSchema_OLD {
  batch_label: string;
  movement_type: InvMovementType;
  associated_id?: string;
  associated_table?: string;
  notes?: string;
  movements: InvMovFull[];
}

export interface InvMovBatchRef extends BaseFullSchema_OLD {
  batch_label: string;
  movement_type: InvMovementType;
  associated_id?: string;
  associated_table?: string;
  notes?: string;
}

export interface InvMovBatchCreate extends BaseCreateSchema {
  movement_type: InvMovementType;
  associated_id?: string;
  associated_table?: string;
  notes?: string;
  movements: InvMovCreate[];
}
export type PaginatedInvMovResponse = PaginatedResponse<InvMovFull>;
